import { enumDocumentRelatedEntityType, enumDocumentRootEntityType, enumDocumentType } from '@app/data-layer/enums/documents';
import { DocumentModel } from '@app/data-layer/models/documents';

// Doc types that must always render on the entry-level (left-of-divider) side, regardless of
// the relatedEntityId / rootEntityId fields the backend sends. See ticket #13006.
export const ALWAYS_ENTRY_LEVEL_DOC_TYPES: readonly enumDocumentType[] = [enumDocumentType.ACH_APPROVAL];

// POA has its own dedicated slot at the far left of the strip and is rendered separately —
// not part of the generic entry-level docs list.
const POA_TYPES: readonly enumDocumentType[] = [enumDocumentType.POWER_OF_ATTORNEY, enumDocumentType.POWER_OF_ATTORNEY_TRUCKER];

export function isEntryLevelEsDocument(
  doc: DocumentModel,
  entrySummaryId: number,
  extraSkippedTypes: readonly enumDocumentType[] = [],
): boolean {
  if (POA_TYPES.includes(doc.type) || extraSkippedTypes.includes(doc.type)) {
    return false;
  }
  if (ALWAYS_ENTRY_LEVEL_DOC_TYPES.includes(doc.type)) {
    return true;
  }
  return (
    doc.relatedEntityId === entrySummaryId &&
    doc.rootEntityId === entrySummaryId &&
    doc.rootEntityType === enumDocumentRootEntityType.ENTRY_SUMMARY
  );
}

export function remapEntryLevelDocToFirstShipment(doc: DocumentModel, firstShipmentId: number): DocumentModel {
  doc.relatedEntityId = firstShipmentId;
  doc.relatedEntityType = enumDocumentRelatedEntityType.SHIPMENT;
  return doc;
}
